import { render } from "./CruResourceFooter.vue?vue&type=template&id=68ad4e37&scoped=true"
import script from "./CruResourceFooter.vue?vue&type=script&lang=js"
export * from "./CruResourceFooter.vue?vue&type=script&lang=js"

import "./CruResourceFooter.vue?vue&type=style&index=0&id=68ad4e37&lang=scss&scoped=true"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ad4e37"]])

export default __exports__